import { useReduxContext } from './useReduxContext'

export function useStore() {
    const { store } = useReduxContext()
    return store
}
